/* eslint-disable import/no-anonymous-default-export */
import { useContext, useCallback } from 'react';
import { AjaxContext, AppContext, formatListData } from 'commons-ui';
import _get from 'lodash/get';
import _keys from 'lodash/keys';
import { convertSplashConfig } from './formDataParser';
import { EConfigUpdateURL, EConfigUpdateURLQueryParams } from './constants';

const useService = () => {
	const { getData, postData } = useContext(AjaxContext);
	const {
		app: { appName }
	} = useContext(AppContext);
	const getKeyValue = async () => {
		const result = await getData({
			endpoint: EConfigUpdateURL.GET_DEFAULT_VALUE_FOR_KEY,
			queryParams: {
				serviceName: EConfigUpdateURLQueryParams.serviceName,
				game: EConfigUpdateURLQueryParams.game,
				key: EConfigUpdateURLQueryParams.key,
				appName
			}
		});
		const formattedResult = convertSplashConfig(result);
		const servicesData = _get(formattedResult, ['data', 'config'], {});
		const rowCount = _keys(servicesData).length;
		const formattedData = formatListData(servicesData);
		return { rowCount, data: formattedData };
	};

	const getKeyValueV2 = useCallback(async () => {
		const result = await getData({
			endpoint: EConfigUpdateURL.GET_DEFAULT_VALUE_FOR_KEY,
			queryParams: {
				serviceName: EConfigUpdateURLQueryParams.serviceName,
				game: EConfigUpdateURLQueryParams.game,
				key: EConfigUpdateURLQueryParams.key,
				appName
			}
		});
		const formattedResult = convertSplashConfig(result);
		const servicesData = _get(formattedResult, ['data', 'config'], {});
		const rowCount = _keys(servicesData).length;
		const formattedData = formatListData(servicesData);
		return { rowCount, data: formattedData };
	}, [getData, appName]);

	const requestUpdateConfig = useCallback(
		async (updatedData: any) => {
			const result = await postData({
				endpoint: EConfigUpdateURL.UPDATE_ZK_KEY_PARTIALLY,
				queryParams: {
					serviceName: EConfigUpdateURLQueryParams.serviceName,
					game: EConfigUpdateURLQueryParams.game,
					key: EConfigUpdateURLQueryParams.key,
					appName
				},
				body: updatedData
			});
			return result;
		},
		[postData]
	);
	const requestPromoteOnProd = useCallback(async () => {
		const result = await postData({
			endpoint: EConfigUpdateURL.PROMOTE_TO_PROD_DIRECTLY,
			queryParams: {
				serviceName: EConfigUpdateURLQueryParams.serviceName,
				game: EConfigUpdateURLQueryParams.game,
				key: EConfigUpdateURLQueryParams.key,
				appName
			}
		});
		return result;
	}, [postData]);

	return {
		getKeyValue,
		getKeyValueV2,
		requestUpdateConfig,
		requestPromoteOnProd
	};
};

export default useService;
